var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"page-content__links"},_vm._l((_vm.links),function(link){return _c('li',{key:link.url},[_c('RouterLink',{class:link.classes ? link.classes : '',attrs:{"to":link.url ? link.url : '/'}},[_c('span',[_vm._v(_vm._s(link.text))])])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }